<template>
  <ul
    class="play-nav"
    :class="[
      align ? `play-nav--${align}` : null,
      { 'play-nav--vertical': vertical },
    ]"
  >
    <slot />
  </ul>
</template>

<script>
/**
 * PlayNav — a group of nav items for the Play system.
 *
 * Token-driven (see src/styles/tokens.scss). Replaces bootstrap-vue's
 * <b-navbar-nav> / <b-nav>. A flex list of <PlayNavItem>s (or <PlayDropdown>
 * for a nav dropdown). `align` distributes them (start/center/end); `vertical`
 * stacks them.
 *
 * VUE3-MIGRATION: nothing Vue 2-specific — already Vue 3-safe.
 */
export default {
  name: 'PlayNav',
  props: {
    align: {
      type: String,
      default: '',
      validator: v => ['', 'start', 'center', 'end'].includes(v),
    },
    vertical: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.play-nav {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding: 0;
  list-style: none;

  &--vertical {
    flex-direction: column;
    align-items: stretch;
  }

  &--start  { justify-content: flex-start; }
  &--center { justify-content: center; }
  &--end    { justify-content: flex-end; margin-left: auto; }
}
</style>
